<template>
  <div>
    <Modal
      ref="modal"
      title="Delete job city"
      body="Are you sure you want to delete this city? This action can be reversed by adding the city again later."
      action="Delete"
      action-color="red"
      @close-modal="handleCancel"
      @handle-action="handleDeactivate"
    />
  </div>
</template>

<script>
import Modal from '../shared/Modal.vue';
import { deactivateJobLocation } from '../../api/jobs';
import { toast } from 'vue-sonner';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';

export default {
  name: 'JobCityDelete',
  components: {
    Modal,
  },
  props: {
    jobLocationId: {
      type: [Number, String],
      required: true,
    },
    v2JobId: {
      type: [Number, String],
      required: true,
    },
  },
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  methods: {
    async handleDeactivate() {
      if (!this.validateIds()) {
        return;
      }

      try {
        await deactivateJobLocation({
          jobId: this.v2JobId,
          locationId: this.jobLocationId,
        });

        this.handleSuccess();
      } catch (error) {
        this.handleError(error);
      }
    },

    validateIds() {
      if (!this.jobLocationId || !this.v2JobId) {
        console.error('Missing required IDs:', { jobLocationId: this.jobLocationId, v2JobId: this.v2JobId });
        return false;
      }
      return true;
    },

    handleSuccess() {
      if (this.$refs.modal && typeof this.$refs.modal.success === 'function') {
        this.$refs.modal.success();
      } else {
        this.loadingSpinnerStore.hideLocalLoadingSpinner();
      }

      this.$emit('handleJobCityDelete');
      toast.success('City deleted', {
        action: { label: 'Dismiss' },
        description: 'The city was successfully deleted. You can add it back later if needed.',
      });
    },

    handleError(error) {
      console.error('Failed to delete job location:', error);
      toast.error('Failed to delete city', {
        action: { label: 'Dismiss' },
        description: 'There was an error deleting the city. Please try again.',
      });
    },

    handleCancel() {
      this.$emit('handleJobCityDeleteCancel');
    },
  },
};
</script>
